<div class="mb-2 report-text">
  <div class="d-flex justify-content-between align-items-start">
    <div>
      <p class="f-18 font-weight-600">Talent Pool Report</p>
      <p class="f-14"><span class="text-969696">Based on</span><span *ngIf="tabName == 'quick_search'"> Quick
          Search</span>
        <span *ngIf="tabName == 'job_description'"> Job Description</span>
      </p>
    </div>
    <div class="btn-section">
      <button data-testid="auto-app-talentpool-report-section-button-1" class="btn-primary-light mr-3" (click)="scrollToFreeTrial('Get_Export_Report_Free_Trial')"><i class="far fa-download"></i>
        <span class="btn-text"> Export Report</span>
      </button>
      <button data-testid="auto-app-talentpool-report-section-button-2" class="btn-gen-ai" (click)="scrollToFreeTrial('Get_AI_Summary_Free_Trial')"> <i class="far fa-wand-magic-sparkles"></i>
        <span class="btn-text">AI Summary</span>
      </button>
    </div>
  </div>
  <div class="d-flex justify-content-between align-items-start align-items-sm-start flex-row-reverse flex-sm-row">
    <div class="chips-container" id="modal-viewMore">
      <div class="d-flex flex-wrap">
        <span class="chips-freemium" *ngFor="let chip of filterChips | slice: 0:5">
          <span class="text-truncate text-capitalize" matTooltip="{{chip?.name}}"
            [matTooltipClass]="{ 'red-tooltip text-black': true }">{{chip?.field}}</span>
          <i class="fas fa-thumbtack" *ngIf="chip?.isMandatory"></i>
        </span>
        <span class="f-12 pointer text-webbtree-green mx-2" *ngIf="filterChips?.length > 4"
          (click)="viewmoredetails('viewMore')">
          View More
        </span>
      </div>
    </div>
    <div class="chips-container" id="modal-viewLess" style="display: none;">
      <div class="d-flex flex-wrap">

        <span class="chips-freemium" *ngFor="let chip of filterChips">
          <span class="text-truncate text-capitalize" matTooltip="{{chip?.name}}"
            [matTooltipClass]="{ 'red-tooltip text-black': true }">{{chip?.field}}</span>
          <i class="fas fa-thumbtack" *ngIf="chip?.isMandatory"></i>
        </span>
        <span class="f-12 pointer text-webbtree-green mx-2" *ngIf="filterChips?.length > 4"
          (click)="viewmoredetails('viewLess')">
          View Less
        </span>
      </div>
    </div>
    <div class="btn-section">
      <button data-testid="auto-app-talentpool-report-section-button-3" class="btn-filter" (click)="openFilterModal()"> <i class="far fa-filters"></i>&nbsp; <span class="btn-text">Filter</span></button>
    </div>
  </div>
</div>

<div class="d-flex report-text mb-4 tcboxmobile">
  <div class="matrix">
    <div *ngIf="totalCandidatesCountAvailable" class="text-center">
      <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="talent count">
    </div>
    <div *ngIf="!totalCandidatesCountAvailable" class="d-flex">
      <p class="mt-1">Talent Count</p><span>{{formatNumberToIndianFormat(totalCandidatesCount)}}</span>
    </div>

  </div>
  <div class="matrix">
    <div *ngIf="showMedianLoader" class="text-center">
      <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="talent count">
    </div>
    <div *ngIf="!showMedianLoader" class="d-flex">

    <p class="mt-1">Tenure <i class="far fa-info-circle" matTooltip='Median Tenure of the talent' [matTooltipClass]="{ 'big-tooltip text-black': true }"></i></p>
    <span [innerHTML]="getFormattedTenureForMatrix(totalMedianTanureCount)"></span>
    </div>
  </div>
  <div class="matrix">
    <div *ngIf="showMedianLoader" class="text-center">
      <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="talent count">
    </div>
    <div *ngIf="!showMedianLoader" class="d-flex">
      <p class="mt-1">Men</p>
      <span><span class="min"><i class="fas fa-person"></i>&nbsp;</span> {{malePercent}} <span class="min">%</span></span>
      <p class="mt-1">&nbsp;&nbsp;|&nbsp;&nbsp;Women</p>
      <span><span class="min"><i class="fas fa-person-dress"></i>&nbsp;</span> {{femalePercent}} <span
          class="min">%</span></span>
    </div>

  </div>
  <div class="matrix">
    <div *ngIf="showMedianLoader" class="text-center">
      <img src="../../assets/rolling-loader.gif" style="width: 15%;" alt="talent count">
    </div>
    <div *ngIf="!showMedianLoader" class="d-flex">

    <p class="mt-1">Changed Jobs(past 1yr)</p><span>{{formatNumberToIndianFormat(changedJobs)}}</span>
    </div>
  </div>
</div>
